import img1 from "./img/banner.png";
import img2 from "./img/Media.png";
import img3 from "./img/invoice.png";
import img4 from "./img/form.png";
import img5 from "./img/location.png";
import img6 from "./img/Flow List Message.png";
import img7 from "./img/SPM.png";
import img8 from "./img/Multi product.png";
import img9 from "./img/Carousal message.png";
import img10 from "./img/date picker.png";
import img11 from "./img/List Message.png";
import img12 from "./img/LTO message.png";

const TemplateData = [
  {
    temp_name: "Template1",
    temp_category: "marketing",
    temp_sub_category: "seasonal",
    temp_price: "free",
    path: "/template1",
    message_type: "template",
    // temp_message: "template",
    title: "Interactive Address Messages",
    description:
      "This Summer Fashion Sale template offers an interactive shopping experience with URL buttons for easy access to the sale collection, driving customer engagement through a limited-time offer and free shipping.",
    temp_sector: "Retail",
    image: img1,
  },

  {
    temp_name: "Template2",
    temp_category: "utility",
    temp_sub_category: "catalog",
    temp_price: "free",
    path: "/template2",
    message_type: "interactive",
    title: "Interactive Call-to-Action URL Button Message",
    description:
      "This Summer Fashion Sale template offers an interactive shopping experience with URL buttons for easy access to the sale collection, driving customer engagement through a limited-time offer and free shipping.",
    temp_sector: "Retail",
    image: img2,
  },

  {
    temp_name: "Template3",
    temp_category: "authentication",
    temp_sub_category: "authentication",
    temp_price: "free",
    path: "/template3",
    message_type: "template",
    title: "title",
    description:
      "This Summer Fashion Sale template offers an interactive shopping experience with URL buttons for easy access to the sale collection, driving customer engagement through a limited-time offer and free shipping.",
    temp_sector: "Retail",
    image: img3,
  },

  {
    temp_name: "Template5",
    temp_category: "marketing",
    temp_sub_category: "seasonal",
    temp_price: "free",
    path: "/template4",
    message_type: "template",
    title: "title",
    description:
      "This Summer Fashion Sale template offers an interactive shopping experience with URL buttons for easy access to the sale collection, driving customer engagement through a limited-time offer and free shipping.",
    temp_sector: "Retail",
    image: img5,
  },

  {
    temp_name: "Template5",
    temp_category: "marketing",
    temp_sub_category: "seasonal",
    temp_price: "free",
    path: "/template5",
    message_type: "template",
    title: "title",
    description:
      "This Summer Fashion Sale template offers an interactive shopping experience with URL buttons for easy access to the sale collection, driving customer engagement through a limited-time offer and free shipping.",
    temp_sector: "Retail",
    image: img4,
  },


  {
    temp_name: "Template6",
    temp_category: "marketing",
    temp_sub_category: "seasonal",
    temp_price: "free",
    path: "/template6",
    message_type: "template",
    title: "title",
    description:
      "This Summer Fashion Sale template offers an interactive shopping experience with URL buttons for easy access to the sale collection, driving customer engagement through a limited-time offer and free shipping.",
    temp_sector: "Retail",
    image: img6,
  },

  {
    temp_name: "Template7",
    temp_category: "marketing",
    temp_sub_category: "seasonal",
    temp_price: "free",
    path: "/template7",
    message_type: "template",
    title: "title",
    description:
      "This Summer Fashion Sale template offers an interactive shopping experience with URL buttons for easy access to the sale collection, driving customer engagement through a limited-time offer and free shipping.",
    temp_sector: "Retail",
    image: img7,
  },

  {
    temp_name: "Template8",
    temp_category: "marketing",
    temp_sub_category: "seasonal",
    temp_price: "free",
    path: "/template8",
    message_type: "template",
    title: "title",
    description:
      "This Summer Fashion Sale template offers an interactive shopping experience with URL buttons for easy access to the sale collection, driving customer engagement through a limited-time offer and free shipping.",
    temp_sector: "Retail",
    image: img8,
  },

  

  {
    temp_name: "Template9",
    temp_category: "marketing",
    temp_sub_category: "seasonal",
    temp_price: "free",
    path: "/template9",
    message_type: "template",
    title: "title",
    description:
      "This Summer Fashion Sale template offers an interactive shopping experience with URL buttons for easy access to the sale collection, driving customer engagement through a limited-time offer and free shipping.",
    temp_sector: "Retail",
    image: img9,
  },

  {
    temp_name: "Template10",
    temp_category: "marketing",
    temp_sub_category: "seasonal",
    temp_price: "free",
    path: "/template10",
    message_type: "template",
    title: "title",
    description:
      "This Summer Fashion Sale template offers an interactive shopping experience with URL buttons for easy access to the sale collection, driving customer engagement through a limited-time offer and free shipping.",
    temp_sector: "Retail",
    image: img10,
  },

  {
    temp_name: "Template11",
    temp_category: "marketing",
    temp_sub_category: "seasonal",
    temp_price: "free",
    path: "/template11",
    message_type: "template",
    title: "title",
    description:
      "This Summer Fashion Sale template offers an interactive shopping experience with URL buttons for easy access to the sale collection, driving customer engagement through a limited-time offer and free shipping.",
    temp_sector: "Retail",
    image: img11,
  },

  {
    temp_name: "Template12",
    temp_category: "marketing",
    temp_sub_category: "seasonal",
    temp_price: "free",
    path: "/template12",
    message_type: "template",
    title: "title",
    description:
      "This Summer Fashion Sale template offers an interactive shopping experience with URL buttons for easy access to the sale collection, driving customer engagement through a limited-time offer and free shipping.",
    temp_sector: "Retail",
    image: img12,
  },
];

export default TemplateData;
